import { Contact, ContactMethod } from '../types';
import { escapeHtml, sanitizeUrl } from '../utils/security';

export function generateContactMethodsHtml(methods: ContactMethod[]): string {
    return methods.map(method => {
        const sanitizedUrl = sanitizeUrl(method.url);

        return `
            <a href="${sanitizedUrl}"
               target="_blank"
               rel="noopener"
               class="flex flex-col items-center gap-2.5 px-4 py-[26px] bg-creme/5 border border-creme/10 rounded-lg text-creme transition-colors hover:bg-sunset/10 hover:border-sunset group"
               aria-label="${escapeHtml(method.label)} (opens in new tab)"
               title="${escapeHtml(method.label)}">
                <i data-lucide="${escapeHtml(method.icon)}" stroke-width="1.5" class="w-[26px] h-[26px] text-sunset group-hover:scale-110 transition-transform" aria-hidden="true"></i>
                <span class="font-mono text-xs tracking-[1.5px] uppercase text-n300">${escapeHtml(method.label)}</span>
                ${method.value ? `<span class="text-[15px] font-semibold text-creme">${escapeHtml(method.value)}</span>` : ''}
            </a>
        `;
    }).join('');
}

export function buildContact(contact: Contact) {
    const root = document.querySelector('[data-section="contact"]');
    if (!root) return;

    const methodsHtml = generateContactMethodsHtml(contact.methods);

    root.innerHTML = `
        <div class="animate-fadeUp">
            <div class="inline-flex items-center gap-3 mb-[18px]">
                <span class="w-6 h-0.5 bg-sunset block" aria-hidden="true"></span>
                <span class="font-mono text-[13px] font-medium tracking-[2px] uppercase text-sunset">${escapeHtml(contact.kicker)}</span>
                <span class="w-6 h-0.5 bg-sunset block" aria-hidden="true"></span>
            </div>
            <h2 class="text-[clamp(32px,4vw,44px)] leading-[1.1] font-bold tracking-[-1px] text-creme mb-5">${escapeHtml(contact.heading)}</h2>
            <p class="text-lg leading-relaxed text-creme/70 max-w-[36em] mx-auto mb-11">${escapeHtml(contact.intro)}</p>

            <div class="grid sm:grid-cols-3 gap-4">
                ${methodsHtml}
            </div>
        </div>
    `;
}
